import { invokeApi } from "../../bl_libs/invokeApi";

export const menuList = async (data) => {
  const requestObj = {
    path: `/app/get_menu_list`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const defaultMenuListApi = async (data) => {
  const requestObj = {
    path: `/app/get_menu_list/`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const active_coach_list = async () => {
  const requestObj = {
    path: `/api/coach/active_coach_list`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
